import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const shippingCost = 9.99;
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="cart-page__empty">
          <h1>Your cart is empty</h1>
          <Link to="/shop" className="cart-page__continue-btn">
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="cart-page__container">
        <div className="cart-page__header">
          <h1 className="cart-page__title">Your cart</h1>
          <Link to="/shop" className="cart-page__continue-btn">
            Continue shopping
          </Link>
        </div>

        <div className="cart-page__content">
          <div className="cart-page__items">
            <div className="cart-page__items-header">
              <span className="cart-page__column-label cart-page__product-label">
                PRODUCT
              </span>
              <span className="cart-page__column-label cart-page__quantity-label">
                QUANTITY
              </span>
              <span className="cart-page__column-label cart-page__total-label">
                TOTAL
              </span>
            </div>

            <div className="cart-page__items-list">
              {cartItems.map((item) => {
                const product = getProductById(item.id);
                if (!product) return null;
                
                const itemTotal = (parseFloat(product.price.replace(/,/g, "")) * item.quantity).toFixed(2);
                
                return (
                  <div key={`${item.id}-${item.size}-${item.color}`} className="cart-page__item">
                    <div className="cart-page__product-info">
                      <div className="cart-page__product-image">
                        <img src={product.image} alt={product.name} />
                      </div>
                      <div className="cart-page__product-details">
                        <p className="cart-page__product-name">{product.name}</p>
                        {item.size && <p className="cart-page__product-option">Size: {item.size}</p>}
                        {item.color && <p className="cart-page__product-option">Color: {item.color}</p>}
                        <p className="cart-page__product-price">${product.price}</p>
                      </div>
                    </div>

                    <div className="cart-page__quantity">
                      <div className="cart-page__quantity-controls">
                        <button
                          className="cart-page__quantity-btn"
                          onClick={() => updateQuantity(item.id, item.size, item.color, item.quantity - 1)}
                        >
                          −
                        </button>
                        <span className="cart-page__quantity-value">{item.quantity}</span>
                        <button
                          className="cart-page__quantity-btn"
                          onClick={() => updateQuantity(item.id, item.size, item.color, item.quantity + 1)}
                        >
                          +
                        </button>
                      </div>
                      <button
                        className="cart-page__remove-btn"
                        onClick={() => removeFromCart(item.id, item.size, item.color)}
                      >
                        🗑
                      </button>
                    </div>

                    <div className="cart-page__item-total">
                      <p>${itemTotal}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="cart-page__sidebar">
            <div className="cart-page__discount">
              <input
                type="text"
                placeholder="Discount Code"
                className="cart-page__discount-input"
              />
              <button className="cart-page__discount-btn">Apply</button>
            </div>

            <div className="cart-page__totals">
              <div className="cart-page__total-row">
                <span>Subtotal</span>
                <span>${calculateTotal().toFixed(2)}</span>
              </div>

              <div className="cart-page__total-row">
                <span>Shipping</span>
                <span>${shippingCost.toFixed(2)}</span>
              </div>

           
              <div className="cart-page__total-row cart-page__total-row--final">
                <span>EST. TOTAL</span>
                <span>${(calculateTotal() + shippingCost).toFixed(2)}</span>
              </div>

              <button
                className="cart-page__checkout-btn"
                onClick={handleCheckout}
              >
                Check out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
